export function Button({ children, className = "", variant = "default", onClick }) {
  const baseStyles =
    "px-6 py-2 rounded-lg font-medium transition-colors duration-200 cursor-pointer inline-block text-center"

  const variantStyles = {
    default: "bg-purple-600 hover:bg-purple-700 text-white",
    outline: "border border-gray-800 bg-gray-800 text-white hover:bg-gray-700",
  }

  return (
    <button className={`${baseStyles} ${variantStyles[variant]} ${className}`} onClick={onClick}>
      {children}
    </button>
  )
}

export default Button;
    
